import React from "react"

export default function IconMeetingRoom({ width, height, color }) {
    return (
        <svg version={1.0} xmlns="http://www.w3.org/2000/svg" width={width ?? "512pt"} height={height ?? "512pt"} viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill={color ?? "currentColor"} stroke="none">
                <path d="M1423 4005 c-153 -43 -248 -139 -288 -290 -8 -33 -15 -76 -15 -98 l0
-38 62 3 63 3 7 57 c18 144 114 235 258 246 80 5 133 -8 196 -51 58 -38 100
-113 112 -197 l7 -55 64 -3 64 -3 -6 60 c-18 170 -119 304 -267 356 -65 23
-194 28 -257 10z" />
                <path d="M2455 4006 c-80 -20 -148 -60 -203 -120 -60 -66 -92 -143 -100 -238
l-5 -68 61 0 60 0 12 69 c25 152 131 241 286 241 148 0 259 -103 280 -257 l7
-53 58 0 c32 0 60 4 64 9 10 17 -15 144 -40 198 -78 172 -286 267 -480 219z" />
                <path d="M3471 4005 c-120 -34 -210 -108 -257 -209 -25 -54 -44 -137 -44 -188
l0 -29 63 3 62 3 7 54 c9 81 54 160 112 198 63 43 116 56 197 51 144 -11 239
-104 258 -253 l6 -50 64 -3 64 -3 -7 66 c-17 166 -109 290 -259 347 -69 26
-197 32 -266 13z" />
                <path d="M1322 3319 c-111 -22 -209 -95 -257 -192 -41 -84 -47 -176 -43 -623
5 -452 7 -466 71 -556 42 -60 95 -102 165 -130 l57 -23 1245 0 1245 0 57 23
c70 28 123 70 165 130 64 90 66 104 71 556 4 442 -2 535 -42 622 -45 99 -143
171 -261 193 -71 13 -2406 13 -2473 0z m2514 -146 c51 -27 98 -80 115 -130 20
-55 20 -911 0 -966 -17 -50 -64 -103 -115 -130 l-41 -22 -1235 0 -1235 0 -41
22 c-57 30 -100 83 -119 145 -22 77 -22 859 0 936 24 79 83 137 165 163 14 4
574 7 1245 6 l1220 -2 41 -22z" />
                <path d="M1123 1477 c15 -165 107 -290 254 -348 74 -29 232 -32 303 -5 150 56
249 188 267 357 l6 60 -64 -3 -64 -3 -7 -55 c-23 -163 -143 -259 -308 -248
-144 11 -240 102 -258 246 l-7 57 -64 3 -64 3 6 -64z" />
                <path d="M2152 1473 c15 -191 145 -332 338 -365 182 -31 372 65 445 225 25 54
50 181 40 198 -4 5 -32 9 -64 9 l-58 0 -7 -52 c-21 -155 -132 -258 -280 -258
-155 0 -261 89 -286 241 l-12 69 -60 0 -61 0 5 -67z" />
                <path d="M3174 1475 c17 -167 106 -288 253 -346 81 -32 233 -32 313 -1 126 51
215 153 244 282 9 38 16 83 16 100 l0 31 -62 -3 -63 -3 -7 -54 c-9 -81 -54
-160 -112 -198 -63 -43 -116 -56 -197 -51 -148 11 -245 112 -261 273 -3 30 -4
30 -67 33 l-64 3 7 -66z" />
            </g>
        </svg>
    )
}
